import { IoTEventsToSynchroChartsComparisonOperator } from './constants';
export class Cache {
    constructor(client) {
        this.alarmModels = {};
        this.client = client;
    }
    async getAlarmModel(name) {
        if (this.alarmModels[name]) {
            return this.alarmModels[name];
        }
        const { severity, alarmRule } = await this.client.getAlarmModel(name);
        if (!(alarmRule === null || alarmRule === void 0 ? void 0 : alarmRule.simpleRule)) {
            throw new Error('Could not get alarm rule');
        }
        const { inputProperty, comparisonOperator, threshold } = alarmRule.simpleRule;
        if (!inputProperty || !comparisonOperator || !threshold || !severity) {
            throw new Error('Could not parse alarm');
        }
        const inputPropertyId = inputProperty;
        const scComparisonOperator = IoTEventsToSynchroChartsComparisonOperator[comparisonOperator];
        const thresholdPropertyId = threshold;
        const alarm = {
            inputPropertyId,
            comparisonOperator: scComparisonOperator,
            thresholdPropertyId,
            severity,
        };
        this.alarmModels[name] = alarm;
        return alarm;
    }
}
